import { createFeatureSelector } from '@ngrx/store';
import {
  CampaignManagementState,
  CampaignSearchResponse,
  CostState,
  DateState,
  DownloadRecipientsState,
} from '../models/campaign-management.model';
import { CancelCampaignReducer } from './cancel-campaign.reducer';
import { CostReducer } from './cost.reducer';
import { DateReducer } from './date.reducer';
import { DownloadRecipientsReducer } from './download-recipients.reducer';
import { CampaignManagementReducer } from './search.reducers';

export const featureCampaignManagementName = 'CampaignManagement';

export interface DragonflyCampaignManagementState {
  search: CampaignManagementState;
  date: DateState;
  cost: CostState;
  downloadRecipients: DownloadRecipientsState;
  cancelCampaign: CampaignSearchResponse;
}

export const moduleCampaignManagementReducers = {
  search: CampaignManagementReducer,
  date: DateReducer,
  cost: CostReducer,
  downloadRecipients: DownloadRecipientsReducer,
  cancelCampaign: CancelCampaignReducer,
};

export const getDragonflyCampaignManagementState =
  createFeatureSelector<DragonflyCampaignManagementState>(featureCampaignManagementName);
